<template>
  <div
    class="modal fade"
    :class="{ show: isVisible }"
    tabindex="-1"
    v-if="isVisible"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t("SaveAsReport") }}</h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="reportName" class="form-label">{{ $t("ReportName") }} *</label>
            <input
              type="text"
              class="form-control"
              id="reportName"
              v-model="reportName"
              :placeholder="$t('EnterReportName')"
              @keyup.enter="saveReport"
            />
          </div>
          <div class="mb-3">
            <label for="reportDescription" class="form-label">{{ $t("Description") }}</label>
            <textarea
              class="form-control"
              id="reportDescription"
              v-model="reportDescription"
              rows="3"
              :placeholder="$t('EnterReportDescription')"
            ></textarea>
          </div>
          <div class="mb-3">
            <label class="form-label">{{ $t("ReportIcon") }}</label>
            <icon-picker v-model="selectedIcon" />
          </div>
          <div class="form-check mb-3">
            <input
              class="form-check-input"
              type="checkbox"
              id="isPublic"
              v-model="isPublic"
            />
            <label class="form-check-label" for="isPublic">
              {{ $t("MakeReportPublic") }}
            </label>
          </div>
          <div class="alert alert-info">
            <small>
              {{ $t("ReportSaveInfo") }}
              <ul class="mb-0 mt-2">
                <li>{{ $t("ReportSaveInfoColumns") }}</li>
                <li>{{ $t("ReportSaveInfoColumnLabels") }}</li>
                <li>{{ $t("ReportSaveInfoWidths") }}</li>
                <li>{{ $t("ReportSaveInfoFilters") }}</li>
                <li>{{ $t("ReportSaveInfoSort") }}</li>
                <li>{{ $t("ReportSaveInfoPagination") }}</li>
              </ul>
            </small>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">
            {{ $t("Cancel") }}
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="saveReport"
            :disabled="!reportName.trim() || isSaving"
          >
            <span
              v-if="isSaving"
              class="spinner-border spinner-border-sm me-2"
              role="status"
            ></span>
            {{ $t("SaveReport") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wencesApi } from "@/api/wencesApi";
import Swal from "sweetalert2";
import IconPicker from "./IconPicker.vue";

export default {
  name: "SaveReportModal",
  components: { IconPicker },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    modelName: {
      type: String,
      required: true,
    },
    viewId: {
      type: String,
      default: null,
    },
    reportData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reportName: "",
      reportDescription: "",
      isPublic: false,
      isSaving: false,
      selectedIcon: "file-alt",
    };
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        // Reset form when modal opens
        this.reportName = "";
        this.reportDescription = "";
        this.isPublic = false;
        this.selectedIcon = "file-alt";
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async saveReport() {
      if (!this.reportName.trim()) {
        Swal.fire({
          icon: "error",
          title: this.$tn("error"),
          text: this.$tn("PleaseEnterReportName"),
        });
        return;
      }

      this.isSaving = true;

      try {
        const reportPayload = {
          name: this.reportName.trim(),
          description: this.reportDescription.trim(),
          modelName: this.modelName,
          viewId: this.viewId || null,
          isPublic: this.isPublic,
          icon: this.selectedIcon,
          ...this.reportData,
        };

        const response = await wencesApi.post("/api/gotrading/reports", reportPayload);

        Swal.fire({
          icon: "success",
          title: this.$tn("success"),
          text: this.$tn("ReportSavedSuccessfully"),
          timer: 2000,
          showConfirmButton: false,
        });

        // Emitir el reporte creado con su ID para redirección
        this.$emit("saved", response.data);
        this.close();
      } catch (error) {
        console.error("Error saving report:", error);
        const errorMessage =
          error.response?.data?.error || "Error saving report";
        Swal.fire({
          icon: "error",
          title: this.$tn("error"),
          text: errorMessage || this.$tn("ErrorSavingReport"),
        });
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.modal {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal.show {
  display: block;
}
</style>

